interface RoleSeats {
  responsibleId?: string
  participantIds: string[]
}

// True when the person creating the org holds none of the roles typed in the
// setup. Rights (e.g. creating a meeting) come from being in a circle, so such
// a person is seated in the root circle, or they would be locked out of their
// own org. Also covers an empty org and a skipped roles step (no roles at all).
export function creatorNeedsRootSeat(
  roles: RoleSeats[],
  creatorMemberId: string
): boolean {
  return !roles.some(
    (role) =>
      role.responsibleId === creatorMemberId ||
      role.participantIds.includes(creatorMemberId)
  )
}
